let language = {
    "TAXES-ALERT-DELETE-TITLE":"Delete Vat",
    "TAXES-ALERT-DELETE-OBJECT-CONTENT":"Are you sure you want to delete the addition of the current VAT ?",
    "TAXES-ALERT-DELETE-CONTENT":"Are you sure you want to delete this VAT?",
    "TAXES-ALERT-DELETE-FAIL-TITLE":"VAT deletion failure",
    "TAXES-ALERT-DELETE-FAIL-CONTENT":"The VAT deletion failed this time, please try to delete it again later.",
    "TAXES-ALERT-DELETE-BUSINESS-TITLE":"Account Details",
    "TAXES-ALERT-DELETE-BUSINESS-CONTENT":"The business information of the account is incomplete .",
    "TAXES-ALERT-DELETE-FORM-TITLE":"Submit VAT",
    "TAXES-ALERT-DELETE-FORM-CONTENT":"Please check that the VAT information you submitted is correct .",
    "TAXES-ALERT-DELETE-CONFIRM-TITLE":"Confirmation information",
    "TAXES-ALERT-DELETE-CONFIRM-CONTENT":`Hereby I confirm that the provided VAT ID number is assigned to my business and should be used 
    going forward to identify my business for the billing and tax reporting purposes .`,
    "TAXES-ALERT-ADD-FORM-TITLE":"Submit VAT",
    "TAXES-ALERT-ADD-FORM-CONTENT":"Please fill in the VAT information you would like to submit .",
    "TAXES-ALERT-ADD-FORM-FAIL-TITLE":"VAT addition failure",
    "TAXES-ALERT-ADD-FORM-FAIL-CONTENT":"The VAT addition failed this time, please try to add VAT again later .",
    "TAXES-ALERT-ADD-FORM-DISABLED-TITLE":"Duplicate vat country",
    "TAXES-ALERT-ADD-FORM-DISABLED-CONTENT":"This country has added vat, please change another country.",
    "TAXES-MESSAGE-DELETE-SUCCESS":"Delete successfully!",
    "TAXES-MESSAGE-ADD-SUCCESS":"Submit vats Successfully!",
    "TAXES-MODAL-QUIT-TITLE":"Exemption Certificate Wizard",
    "TAXES-MODAL-QUIT-CONTENT":"Are you sure you want to exit the Wizard?",
};

export { language }